import { AxiosResponse } from "axios";
import AxiosService from "./Axios";
import BaseApi from "./BaseApi";

const BASE_URL = "/scene";

class SceneApi extends BaseApi {

    constructor() {
        super(BASE_URL);
    }

    public async getSceneViews() {
        return AxiosService.get(BASE_URL + '/scene-view/all');
    }

    public async getSceneViewById(sceneId: string) {
        return AxiosService.get(BASE_URL + '/scene-view/id/' + sceneId);
    }
    
    public async queryViews(request: QuerySceneViewsRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/scene-view/query', request);
    }

    public async getSceneDeviceView(sceneId: string) {
        return AxiosService.get(BASE_URL + '/scene-device-views', {
            params: {
                sceneId: sceneId
            }
        });
    }

    public async getDeviceViewsForNewMapping() {
        return AxiosService.get(BASE_URL + '/device-views-for-new-mapping');
    }

    public async addDevices(sceneId: string, deviceIds: string[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/add-mappings', {
            sceneId: sceneId,
            deviceIds: deviceIds
        });
    }

    public async removeDevices(sceneId: string, deviceIds: string[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/delete-mappings', {
            sceneId: sceneId,
            deviceIds: deviceIds
        });
    }
}

interface QuerySceneViewsRequest {
    pageNo: number;
    pageSize: number;
    search?: string;
}

export default SceneApi;
